// import React, { useState } from "react";
// import { Carousel } from "primereact/carousel";
// import { responsiveSliderOptions } from "../../assets/config";
// import { SmallHadding } from "molecules/SmallHeadding";
// import { DetailBox } from "../../molecules/DetailBox";

// import { QuantamVideo } from "container/QuantamVideo";
// export const MainSlider = (props) => {
//   const productTemplate = (item, index) => {
//     return (
//       <div className="text-justify p-3 insightDiv responsiveDiv " onClick={() => props.onSlideClick(index)}> {/* Call onSlideClick with index */}
//         {item.image ? (
//           <div className="image-container">
//           <img
//             src={item.image}
//             className="w-full zoom-image"
//           />
//           </div>
//         ) : (
//           <QuantamVideo item={item} />
//         )}

//         {/* <SmallHadding text={item.title} className={`${props.titlecss} mt-3`} /> */}
//         <h2 className={`${props.titlecss} mt-3 underlineText`} >
//           {item.title}
//         </h2>
//         <DetailBox
//           details={item.description}
//           className={` ${props.detailcss}`}
//         />
//       </div>
//     );
//   };

//   return (
//     <Carousel
//       value={props.data}
//       numVisible={3}
//       numScroll={1}
//       responsiveOptions={responsiveSliderOptions}
//       itemTemplate={productTemplate}
//       showIndicators={false}
//       showNavigators={false}
//       autoplayInterval={3000}
//       circular={true}
//       style={{ backgroundColor: "transparent" }}
//     />
//   );
// };


import React, { useEffect, useState } from "react";
import { Carousel } from "primereact/carousel";
import { Paginator } from "primereact/paginator"; // Import the Paginator
import { SmallHadding } from "molecules/SmallHeadding";
import { DetailBox } from "../../molecules/DetailBox";
import { QuantamVideo } from "container/QuantamVideo";
import styled from "styled-components";

/**
 * Prime Carousel "page" advances by numScroll. Paginator advances by chunks of size `rows`.
 * Shared config uses numScroll: 1, so carousel page count diverges from the paginator (e.g.
 * 6 items / 3 visible → 4 carousel steps but only 2 paginator pages) and trailing slides stay unreachable.
 */
const mainSliderResponsiveOptions = [
  { breakpoint: "1400px", numVisible: 3, numScroll: 3 },
  { breakpoint: "1199px", numVisible: 3, numScroll: 3 },
  { breakpoint: "768px", numVisible: 1, numScroll: 1 },
  { breakpoint: "575px", numVisible: 1, numScroll: 1 },
];

// Custom Styled Paginator
const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }

  .p-paginator-pages {
    margin: 0 1rem;
  }
  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }

  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

export const MainSlider = (props) => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(3); // Number of visible items
  const [activePage, setActivePage] = useState(0);

  useEffect(() => {
    setFirst(0);
    setActivePage(0);
  }, [props.data?.length]);

  const renderDefaultSlideMedia = (item) =>
    item.image ? (
      <div className="image-container2 ">
        <img
          src={item.image}
          className="w-full zoom-image"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    ) : (
      <QuantamVideo item={item} />
    );

  const productTemplate = (item, index) => {
    const slideMedia =
      typeof props.renderSlideMedia === "function"
        ? props.renderSlideMedia(item, index)
        : renderDefaultSlideMedia(item);
    return (
      <div className=" p-0 mr-1 insightDiv responsiveDiv d-flex align-items-start flex-column alignTextLeft " onClick={() => props.onSlideClick(index)}>
        {slideMedia}
        <h2 className={`${props.titlecss} mt-3 underlineText  fontAva font19 alignTextLeft`} style={{fontSize:"1.5rem",textAlign:"left"}}>
          {item.title}
        </h2>
        <DetailBox details={item.description} className={`${props.detailcss}`} />
      </div>
    );
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setActivePage(event.page);
  };

  return (
    <div className="container  p-0 ">
      <Carousel
        key={props.data?.length ?? 0}
        value={props.data}
        page={activePage}
        numVisible={rows} // Updated to reflect the rows state
        numScroll={rows}
        responsiveOptions={mainSliderResponsiveOptions}
        itemTemplate={productTemplate}
        showIndicators={false}
        showNavigators={false}
        circular={true}
        style={{ backgroundColor: "transparent" }}
       
      />

      <div className="container paddingZeroForDesk flex justify-content-end flex-wrap mb-4 p-0 ">
      <CustPaginator
  first={first}
  rows={rows}
  totalRecords={props.data.length}
  onPageChange={onPageChange}
  prevPageLinkIcon={<i className="pi pi-arrow-circle-left" style={{ fontSize: "2rem" }}></i>}
  nextPageLinkIcon={<i className="pi pi-arrow-circle-right" style={{ fontSize: "2rem" }}></i>}
  currentPageReportTemplate="{currentPage} of {totalPages}"  // Custom report template without parentheses
  template="PrevPageLink CurrentPageReport NextPageLink"  // Template layout
/>
      </div>
    </div>
  );
};
